<template>
    <div class="center-page">
        <div style="line-height: 1.5;" v-html="detail.content"></div>
    </div>
</template>

<script>
    export default {
        name: "aboutUs",
        data() {
            return {
                detail: ''
            }
        },
        created() {
            this.gywm()
        },
        methods: {
            async gywm() {
                let [e, data] = await this.$api.gywmApi();
                this.detail = data.result;

            }
        },
    }
</script>

<style scoped>

</style>
